import { ToastProps } from '@procore/core-react/dist/_typedoc/Toast/Toast.types.json';
import * as React from 'react';
export default {
  ToastProps,
  React
};